<app-nav-bar>
  <ul mobile class="nav-bar__mobile__items">
    @if (canViewAddUserButton$ | async) {
      <li class="nav-bar__mobile__item" data-testid="header-add-user">
        <button (click)="openAddUserToThisSession()" data-testid="header-add-user">Add Participant</button>
      </li>
    }
    @if (canViewDeviceSettingsButton$ | async) {
      <li class="nav-bar__mobile__item">
        <button (click)="openChangeAudioVideoModal()" data-testid="header-device-settings">
          Device Settings
        </button>
      </li>
    }
    @if (canViewOrderDetailsButton$ | async) {
      <li class="nav-bar__mobile__item">
        <button (click)="openDetailsModal()" data-testid="header-order-details">Order Details</button>
      </li>
    }
    @if (canViewIdVerifyButton$ | async) {
      <li class="nav-bar__mobile__item">
        <button (click)="openIdVerifyModal()" data-testid="header-id-verify">
          ID Verify
        </button>
      </li>
    }
    @if (isHelpFaqEnabled && hasAssociatedUsersAndPackage()) {
      <li class="nav-bar__mobile__item">
        <button (click)="faqWidgetService.open()" data-testid="header-faqs-mobile">FAQs</button>
      </li>
    }
    <li class="nav-bar__mobile__item" data-testid="header-privacy-policy">
      <a target="_blank" href="https://www.rocketclose.com/privacy-policy" rel="noopener">Privacy Policy</a>
    </li>
    <li class="nav-bar__mobile__item" data-testid="header-terms-of-use">
      <a target="_blank" href="https://www.rocketclose.com/terms-of-use" rel="noopener">Terms of Use</a>
    </li>
    <li class="nav-bar__mobile__item">
      <button (click)="openCancelSigningModal()" data-testid="header-cancel-signing">
        Cancel Signing
      </button>
    </li>
    <li class="nav-bar__mobile__item">
      <app-support-phone-number-button></app-support-phone-number-button>
    </li>
  </ul>

  @if (isHelpFaqEnabled && hasAssociatedUsersAndPackage()) {
    <button mat-button class="faq-nav-button" data-testid="header-faqs" (click)="faqWidgetService.open()">
      <mat-icon aria-hidden="true">help_outline</mat-icon>
      FAQs
    </button>
  }

  <app-support-phone-number-button></app-support-phone-number-button>

  <app-add-user-to-this-session-button [isAddUserButtonEnabled]="canViewAddUserButton$ | async"></app-add-user-to-this-session-button>

  <app-menu [isDeviceSettingsButtonEnabled]="canViewDeviceSettingsButton$ | async"
    [isOrderDetailsButtonEnabled]="canViewOrderDetailsButton$ | async"
    [isIdVerifyButtonEnabled]="canViewIdVerifyButton$ | async"
    [isPrivacyPolicyButtonEnabled]="true"
    [isTermsOfUseButtonEnabled]="true"
    [isCancelSigningButtonEnabled]="true">
  </app-menu>
</app-nav-bar>
